import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ElementRef,
  HostListener,
  OnDestroy,
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { SessionService } from '../../../backend-adapter/session.service';
import { IAuthenticateData } from './../../../backend-adapter/session.interfaces';
import { SocketService } from '../../../../core/backend-adapter/socket.service';
import { IAccount } from '../../../../acct-comps/accounts.interfaces';
import { Observable, Subject, Subscription, from, of } from 'rxjs';
import { filter, switchMap, takeUntil } from 'rxjs/operators';
import { LocationsFilterService } from '../../../../loc-comps/locations-filter.service';
import { SelectedLocationsStore } from '../../../../loc-comps/selected-locations.store';
import { AutoComplete } from 'primeng/autocomplete';

@Component({
  selector: 'app-top-right-menu-block',
  templateUrl: './top-right-menu-block.component.html',
  styleUrls: ['./top-right-menu-block.component.scss'],
})
export class TopRightMenuBlockComponent implements OnInit, OnDestroy {
  // Multi-select dropdown
  allAdvanceFilters: any[] = [];
  // accountId = 'demo-account-1'; // fake account id
  @Input() currentUser: IAuthenticateData;
  @Output() showChangePwdDialog = new EventEmitter<boolean>();
  @ViewChild('storeCodeAC') storeCodeAC!: AutoComplete;
  public account: IAccount;
  private subs = new Subscription();
  private draftSelectedFilters: { [key: string]: string[] } = {};
  currentItems: any[] = [];
  itemsPerPage = 10;
  currentPage = 1;
  booleanFromData: boolean = true;
  isAndMode: boolean = false; // AND/OR toggle (true = AND, false = OR)

  divVisible: boolean = false;
  menuItemsUser: MenuItem[];
  userLetter = '?';
  menuExpanded = false;
  badgeVisible: boolean = false;
  locCounts: any;
  numberUnread: number;
  showLocationFilterModal = false;
  accountId: number | null = null;
  userId: number | null = null;
  // Typeahead for Store Code
  availableStoreCodes: string[] = [];
  storeCodeInput = '';
  storeCodeResults: string[] = [];
  trackCatByKey = (_: number, cat: { key: string }) => cat.key;
  trackOption  = (_: number, opt: string) => opt;

  private UI_TO_API: Record<string, string> = {
    storeCode: 'storecode',
    businessName: 'business_names',
    city: 'city',
    state: 'states',
    country: 'countries',
    tags: 'tag_list',
    labels: 'label_list',
    categories: 'category_list',
  };
  filterCategories = [
    { label: 'Store code', key: 'storeCode', options: [], expanded: false },
    /*{ label: 'Business name', key: 'businessName', options: [], expanded: false },*/
    { label: 'City', key: 'city', options: [], expanded: false },
    /*{ label: 'State', key: 'state', options: [], expanded: false },*/
    /*{ label: 'Country', key: 'country', options: [], expanded: false },*/
    { label: 'Tags', key: 'tags', options: [], expanded: false },
    { label: 'Labels', key: 'labels', options: [], expanded: false }
  ];

  selectedFilters: { [key: string]: string[] } = {};

  private ngUnsubscribe$ = new Subject();

  @ViewChild('userMenuRef', { static: false }) private userMenuRef: any;
  constructor(
    private locationsFilterService: LocationsFilterService,
    private selStore: SelectedLocationsStore,
    public router: Router,
    public sessionService: SessionService,
    private socketService: SocketService,
    private elementRef: ElementRef
  ) {}

  private buildApiFiltersFromUI(): Record<string, string[] | string> {
    const apiFilters: Record<string, string[] | string> = {};

    Object.entries(this.selectedFilters).forEach(([uiKey, values]) => {
      if (values?.length) {
        const apiKey = this.UI_TO_API[uiKey] ?? uiKey; // e.g. state -> states
        apiFilters[apiKey] = values;
      }
    });

    return apiFilters;
  }

  private setOptions(uiKey: string, values: string[] = []) {
    const cat = this.filterCategories.find((c) => c.key === uiKey);
    if (!cat) return;
    const uniq = Array.from(
      new Set((values || []).map((v) => String(v ?? '').trim()).filter(Boolean))
    );
    cat.options = uniq;
  }
  
  // Filter - Loads on component init
  private loadFacetOptionsFromAPI(): void {
    const accountId = (this.account as any)?._id ?? (this.account as any)?.id ?? (this.account as any)?.accountId;
    const userId = Number(this.sessionService.loginObj?._id ?? this.sessionService.loginObj?._id);
    if (!accountId || !userId) return;
    this.locationsFilterService
      .getFilters(accountId, userId)
      .then((res) => {
        // Map API payload -> your UI keys
        console.log(res);
        this.setOptions('storeCode', [...(res.storecode || [])].sort((a, b) => Number(a) - Number(b)));
        this.setOptions('city', [...(res.city || [])].sort((a, b) => String(a).localeCompare(String(b))));
        /*this.setOptions('businessName', res.business_names || []);*/
        /*this.setOptions('state', res.states || []);*/
        /*this.setOptions('country', res.countries || []);*/
        this.setOptions('tags', [...(res.tag_list || [])].sort((a, b) => String(a).localeCompare(String(b))));
        this.setOptions('labels', [...(res.label_list || [])].sort((a, b) => String(a).localeCompare(String(b))));
        this.availableStoreCodes = (res?.storecode ?? []).map(String); // e.g. ['51125', '51125-clkcol', ...]
      })
      .catch((err) => {
        console.error('Error fetching filters:', err);
      });
  }

  ngOnInit(): void {
    const user$ = this.sessionService.getSelectedAccount$();
    user$.pipe(takeUntil(this.ngUnsubscribe$)).subscribe((user: IAccount) => {
      if (user) {
        this.account = user;
        this.loadFacetOptionsFromAPI();
      }
    });

    this.router.events
      .pipe(
        takeUntil(this.ngUnsubscribe$),
        filter((event) => event instanceof NavigationEnd),
        switchMap((url: NavigationEnd) => {
          if (url.url !== '/login') {
            return from(this.socketService.sendRequest('get-notification-coll', {}));
          } else {
            return of(null);
          }
        })
      )
      .subscribe((notifications: any) => {
        if (notifications !== null) {
          this.locCounts = notifications.collection;
          this.locCounts.forEach((notification) => {
            notification.isRead = Boolean(notification.isRead);
          });
          this.loadItems();
          this.getUnreadNotificationsCount();
          this.shouldShowBadge();
        }
      });
    // Hydrate UI from existing selection (if any)
    const snap = this.selStore.snapshot;
    if (snap?.filters) {
      // Convert API keys back to your UI keys
      const API_TO_UI: Record<string, string> = Object.entries(this.UI_TO_API).reduce((acc, [ui, api]) => {
        acc[api] = ui;
        return acc;
      }, {} as Record<string, string>);

      this.selectedFilters = {}; // reset
      Object.entries(snap.filters).forEach(([apiKey, val]) => {
        const uiKey = API_TO_UI[apiKey] ?? apiKey;
        this.selectedFilters[uiKey] = Array.isArray(val) ? [...val] : val ? [String(val)] : [];
      });
    }

    this.initUserMenu();
    this.getUserLetter();
  }

  get hasStoreCodeFilter(): boolean {
    return (this.selectedFilters?.storeCode?.length ?? 0) > 0;
  }

  get hasOtherFilters(): boolean {
    return Object.keys(this.selectedFilters || {}).some(
      (k) => k !== 'storeCode' && (this.selectedFilters[k]?.length ?? 0) > 0
    );
  }

  get selectedStoreCodes(): string[] {
    return this.selectedFilters?.storeCode ?? [];
  }

  toggleBooleanMode(): void {
    this.isAndMode = !this.isAndMode;
  }

  clearStoreCodes(): void {
    if (!this.selectedFilters) this.selectedFilters = {};
    this.selectedFilters['storeCode'] = [];
  }

  showAllStoreCodes(): void {
    // fill suggestions with the full list and open the panel
    this.storeCodeResults = (this.availableStoreCodes || []).slice(0, 500); // cap if needed
    // PrimeNG exposes show(); guard in case ref isn’t ready yet
    this.storeCodeAC?.show?.();
  }

  onStoreCodePicked(ev: any): void {
    // enforce exclusivity and add selected code
    const code = typeof ev === 'string' ? ev : String(ev?.value ?? ev ?? '');
    if (code?.trim()) {
      this.ensureExclusive('storeCode');
      this.addStoreCode(code.trim());
    }
  }

  private clearNonStoreFilters(): void {
    if (!this.selectedFilters) this.selectedFilters = {};
    Object.keys(this.selectedFilters).forEach((k) => {
      if (k !== 'storeCode') this.selectedFilters[k] = [];
    });
  }

  private ensureExclusive(activeKey: string): void {
    if (activeKey === 'storeCode' && this.hasOtherFilters) {
      this.clearNonStoreFilters();
    } else if (activeKey !== 'storeCode' && this.hasStoreCodeFilter) {
      this.clearStoreCodes();
    }
  }

  searchStoreCodes(e: { query: string }) {
    const q = (e?.query ?? '').toLowerCase().trim();
    const pool = this.availableStoreCodes;
    this.storeCodeResults = q ? pool.filter((c) => c.toLowerCase().includes(q)).slice(0, 25) : pool.slice(0, 25);
  }

  addStoreCode(sel: any) {
    const code = typeof sel === 'string' ? sel.trim() : String(sel ?? '').trim();
    if (!code) return;
    // use your existing selection handler so counters/filters stay in sync
    if (!this.isSelected('storeCode', code)) {
      this.onSelectFilter('storeCode', true, code);
    }
    this.storeCodeInput = '';
    this.storeCodeResults = [];
  }

  removeStoreCode(index: number): void {
    if (!this.selectedFilters?.storeCode) return;
    this.selectedFilters.storeCode = this.selectedFilters.storeCode.filter((_, i) => i !== index);
  }

  // optional: support pressing Enter in the input
  onStoreCodeEnter() {
    const code = this.storeCodeInput.trim();
    if (code) this.addStoreCode(code);
  }

  // TOGGLE: Toggle model open/close
  toggleLocationFilterModal() {
    // when opening, capture a draft snapshot to restore on cancel
    if (!this.showLocationFilterModal) {
      this.draftSelectedFilters = JSON.parse(JSON.stringify(this.selectedFilters || {}));
    }
    this.showLocationFilterModal = !this.showLocationFilterModal;
  }

  // CANCEL: discard in-modal changes and restore previous selection
  cancelFilters() {
    this.selectedFilters = JSON.parse(JSON.stringify(this.draftSelectedFilters || {}));
    this.showLocationFilterModal = false;
  }

  // CLEAR ALL: wipe UI + persisted store
  clearAllFilters() {
    this.selectedFilters = {};
    this.selStore.clear();
    this.clearStoreCodes();
    this.collapseAllCategories();
    this.applyFilters();
  }

  private collapseAllCategories(): void {
    this.filterCategories.forEach((c) => (c.expanded = false));

    // If you use OnPush change detection, force a new reference:
    this.filterCategories = [...this.filterCategories];
  }

  onSelectFilter(key: string, checked: boolean, value: string) {
    this.ensureExclusive(key);

    if (!this.selectedFilters[key]) this.selectedFilters[key] = [];

    if (checked) {
      if (key === 'tags') {
        this.selectedFilters[key] = [value];
        return;
      }

      if (!this.selectedFilters[key].includes(value)) {
        this.selectedFilters[key].push(value);
      }
    } else {
      this.selectedFilters[key] = this.selectedFilters[key].filter((v) => v !== value);
    }
  }
  // SINGLE OPTION: Check if option is selected
  isSelected(key: string, value: string) {
    return this.selectedFilters[key]?.includes(value) || false;
  }
  toggleSelectAll(key: string, checked: boolean) {
    if (checked) this.ensureExclusive(key);

    const cat = this.filterCategories.find((c) => c.key === key);
    if (!cat) return;

    if (!this.selectedFilters[key]) this.selectedFilters[key] = [];

    if (key === 'tags') {
      this.selectedFilters[key] = checked && cat.options?.length ? [cat.options[0]] : [];
      return;
    }

    this.selectedFilters[key] = checked ? (cat.options?.slice() || []) : [];
  }
  // ALL OPTION: Check if all options are selected
  isAllSelected(key: string) {
    const cat = this.filterCategories.find((c) => c.key === key);
    if (!cat) return false;
    return cat.options.length > 0 && cat.options.every((opt) => this.selectedFilters[key]?.includes(opt));
  }

  // Apply filters
  applyFilters() {
    // If store codes are selected, ignore other filters entirely (by exclusivity they should already be cleared)
    const hasSC = this.hasStoreCodeFilter;

    const apiFilters = hasSC ? {} : this.buildApiFiltersFromUI();
    const storeCodes = hasSC ? [...(this.selectedFilters.storeCode || [])] : [];

    // Persist your mode as well, so your data loader knows how to combine categories
    this.selStore.set({
      mode: this.isAndMode ? 'AND' : 'OR',
      filters: apiFilters,
      storeCodes: storeCodes,
    });

    this.showLocationFilterModal = false;
  }

  public initUserMenu(): void {
    this.menuItemsUser = [
      // { label: this.currentUser, icon: 'pi pi-user'},
      // {
      //   label: 'Profile',
      //   command: () => this.router.navigate(['/account-settings']),
      // },
      // {
      //   label: 'Settings',
      //   command: () => this.router.navigate(['/account-settings']),
      // },
      { label: 'Change password', command: () => this.showChangePwdDialog.emit(true) },
      { label: 'Logout', command: (event) => this.userMenuLogout(event) },
    ];
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const clickedInside = this.elementRef.nativeElement.contains(event.target);
    if (!clickedInside) {
      this.divVisible = false;
    }
  }

  getNotifications(): Observable<any> {
    const notification$ = from(this.socketService.sendRequest('get-notification-coll', {}));
    return notification$;
  }

  updateMarkAsRead(notification: any) {
    from(
      this.socketService.sendRequest('save-notification', {
        item: { _id: notification.notificationId, is_read: notification.isRead },
      })
    )
      .pipe(
        switchMap((res) => {
          return of(this.socketService.sendRequest('get-notification-coll', {}));
        })
      )
      .subscribe((res) => {});
  }

  markAllAsRead(locCounts) {
    locCounts.forEach((notification) => {
      if (notification.isRead) {
        return;
      }
      notification.isRead = true;
      from(
        this.socketService.sendRequest('save-notification', {
          item: {
            _id: notification.notificationId,
            is_read: notification.isRead,
          },
        })
      )
        .pipe(
          switchMap((res) => {
            return of(this.socketService.sendRequest('get-notification-coll', {}));
          })
        )
        .subscribe((res) => {});
    });
  }

  private getUnreadNotificationsCount(): number {
    this.numberUnread = this.locCounts.filter((notification) => !notification.isRead).length;
    return this.numberUnread;
  }

  hasUnreadNotifications(): boolean {
    return this.locCounts?.some((notification) => !notification.isRead);
  }

  public userMenuLogout(event): void {
    this.sessionService.deauthenticate();
  }

  //// user menu
  getUserLetter() {
    if (this.currentUser) {
      this.userLetter = this.currentUser.login.loginId.slice(0, 1).toUpperCase();
    }
  }

  toggleUserMenu(event) {
    this.userMenuRef.toggle(event);
    this.menuExpanded = !this.menuExpanded;
  }

  toggleDiv() {
    this.divVisible = !this.divVisible;
    if (this.divVisible) {
      // this.badgeVisible = false;
    }
  }

  // tab menu navigation
  setActiveTab(item) {
    console.log(item);
    this.activeItem = item;
  }
  // tab menu
  tabItems: MenuItem[] = [
    {
      label: 'REVIEWS',
      command: (event) => {
        this.setActiveTab(event.item);
      },
    },
    {
      label: 'NEW LOCATIOINS',
      command: (event) => {
        this.setActiveTab(event.item);
      },
    },
  ];
  activeItem: MenuItem = this.tabItems[0];

  loadItems(): void {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    const newItems = this.locCounts.slice(startIndex, endIndex);
    this.locCounts.forEach((notification) => {
      notification.isRead = Boolean(notification.isRead);
    });
    this.currentItems = [...this.currentItems, ...newItems];
    this.currentPage++;
  }

  onScroll(event: any): void {
    const scrollTop = event.target.scrollTop;
    const scrollHeight = event.target.scrollHeight;
    const clientHeight = event.target.clientHeight;
    const threshold = 5;
    const atBottom = scrollTop + clientHeight >= scrollHeight - threshold;
    if (atBottom) {
      this.loadItems();
    }
  }

  shouldShowBadge(): any {
    if (this.account && this.numberUnread >= 1) {
      this.badgeVisible = true;
    }
  }

  onMoreLessClick(event: MouseEvent): void {
    event.stopPropagation();
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
